export default "__VITE_ASSET__Hfm2axjC__"